module.exports = __webpack_public_path__ + "media/images/map-icons/icons/station-flu-icon-573b9b878c053b3a5cb94b4d7bf21cd3.png";